import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAf-b53KTPBSojjSpwdsso3mUTL4jb9oew",
  authDomain: "arianoir-io.firebaseapp.com",
  projectId: "arianoir-io",
  storageBucket: "arianoir-io.appspot.com",
  messagingSenderId: "753096653249",
  appId: "1:753096653249:web:bf86f315af66cb64809740",
  measurementId: "G-SZNX3DJR7S",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
